import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField } from "@mui/material";

const AddChallengeDialog = ({ addModalOpen, setAddModalOpen, addFormData, handleAddFormChange, categories, handleAddChallenge, saving }) => (
<>
      {/* Add Challenge Modal */}
      <Dialog 
        open={addModalOpen} 
        onClose={() => setAddModalOpen(false)}
        maxWidth="sm"
        fullWidth
        sx={{
          "& .MuiDialog-paper": {
            borderRadius: "12px",
          },
        }}
      >
        <DialogTitle sx={{ fontWeight: 600, borderBottom: "1px solid #eee" }}>
          Add New Challenge
        </DialogTitle>
        <DialogContent sx={{ mt: 2 }}>
          <TextField
            label="Title"
            value={addFormData.title || ""}
            onChange={(e) => handleAddFormChange("title", e.target.value)}
            fullWidth
            margin="normal"
            size="small"
            placeholder="Enter challenge title"
          />
          <TextField
            select
            label="Category"
            value={addFormData.categoryId || ""}
            onChange={(e) => handleAddFormChange("categoryId", e.target.value)}
            fullWidth
            margin="normal"
            size="small"
            SelectProps={{
              native: true,
            }}
          >
            <option value="">Select a category</option>
            {categories.map((cat) => (
              <option key={cat._id} value={cat._id}>
                {cat.name}
              </option>
            ))}
          </TextField>
          <TextField
            label="Start Date & Time"
            type="datetime-local"
            value={addFormData.startDate || ""}
            onChange={(e) => handleAddFormChange("startDate", e.target.value)}
            fullWidth
            margin="normal"
            size="small"
            InputLabelProps={{ shrink: true }}
          />
          <TextField
            label="End Date & Time"
            type="datetime-local"
            value={addFormData.endDate || ""}
            onChange={(e) => handleAddFormChange("endDate", e.target.value)}
            fullWidth
            margin="normal"
            size="small"
            InputLabelProps={{ shrink: true }}
          />
        </DialogContent>
        <DialogActions sx={{ p: 2, borderTop: "1px solid #eee" }}>
          <Button 
            onClick={() => setAddModalOpen(false)}
            sx={{ color: "#666" }}
          >
            Cancel
          </Button>
          <Button 
            onClick={handleAddChallenge}
            variant="contained"
            disabled={saving}
            sx={{ 
              backgroundColor: "#142C5C",
              "&:hover": { backgroundColor: "#0f2247" },
            }}
          >
            {saving ? "Creating..." : "Create Challenge"}
          </Button>
        </DialogActions>
      </Dialog>
</>
);

export default AddChallengeDialog;
